import React, { useState } from 'react'

import Form from 'antd/es/form'
import Input from 'antd/es/input'
import Button from 'components/button'

import { Logo } from '../logo'
import preval from 'preval.macro'
import moment from 'moment'
import ResetPassword from './resetPassword'

import './style.css'
import Notification from 'antd/es/notification'
import axios from 'axios'
import { Modal } from 'antd'

export type LoginAttempt = {
  username: string
  password: string
}

type Props = {
  type: 'email' | 'username'
  logoUrl: string
  backgroundUrl: string
  loginAttempt: (item: LoginAttempt) => void
}

const dateTimeStamp = preval`module.exports = new Date();`

export const Login = (props: Props) => {
  const [showResetPasswordModal, setShowResetPasswordModal] = useState<boolean>(false)
  const [showDisclaimer, setShowDisclaimer] = useState<boolean>(false)

  const onFinish = async (item: LoginAttempt) => {
    console.log('Login with token', item)
    props.loginAttempt(item)
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  const resetPasswordPost = async (email: string) => {
    try {
      await axios.post(global.Config.backendUri + '/resetPassword', { email })
    } catch (e) {
      console.log(e)
      Notification.error({ message: JSON.stringify(e), placement: 'bottomLeft' })
    }
  }

  const usernameFieldName = props.type === 'email' ? 'Email' : 'Username'

  return (
    <div className="c-login__wrapper">
      <Modal
        title={<div style={{ fontWeight: 600 }}>Aputeam Oy:n rekisteri- ja tietosuojaseloste</div>}
        visible={showDisclaimer}
        onCancel={() => {
          setShowDisclaimer(false)
        }}
        footer={<></>}
      >
        <div className="c-login-disclaimer">
          <p>
            Laatimispäivä 15.12.2020 <br /> Päivitetty 29.08.2022
          </p>
          <p>
            <div>1. Rekisterinpitäjä </div> Aputeam Oy, 2436960-3(jäljempänä Aputeam)
            <br /> Eerikinkatu 2 B 16, 20100 Turku
            <br />
            Puh.+358 10 838 3520
          </p>
          <p>
            <div>2. Yhteystiedottietosuoja-asioissa </div> Aputeam Oy:n hallinto, miina.lehtisalo@aputeam.fi
          </p>
          <p>
            <div> 3. Rekisterin nimi</div> Aputeam Oy:n työnhakija- ja työntekijärekisteri
          </p>
          <p>
            <div>4. Henkilötietojen käsittelyn tarkoitus ja käsittelyn oikeusperuste</div>
            <p>
              Henkilötietojen käsittelyn tarkoituksena on rekrytointiasioiden hoitaminen sekä työsuhdeasioiden ja niihin liittyvien
              työnantajavelvoitteiden hoitaminen. Henkilötietoja käsitellään kartoitettaessa työnhakijan sopivuutta avoinna olevaan työtehtävään sekä
              työsuhteeseen liittyvien asioiden ja työnantajavelvoitteiden hoidossa, kuten palkanmaksun ja työajanseurannan toteuttamisessa.
            </p>
            <p>
              Henkilötietojen käsittelyn perusteena ovat lainsäädännössä ja työehtosopimuksissa rekisterinpitäjälle asetetut työnantajavelvoitteet ja
              työntekijälle annetut oikeudet.
            </p>
            <p>
              Henkilötietojen käsittely perustuu myös Aputeamin oikeutettuun etuun käsitellä henkilötietoja rekrytointiprosessin edellyttämällä
              tavalla Aputeamin ja työnhakijan välisessä suhteessa, joka syntyy rekisteröidyn jättäessä työhakemuksen Aputeamille. Henkilötietojen
              käsitteleminen on välttämätöntä työhakemusten käsittelemiseksi ja rekrytoinnin toteuttamiseksi. Joissakin tapauksissa henkilötietojen
              käsittely on tarpeen myös Aputeamin ja työnhakijan välisen työsopimuksen tekemistä edeltävien toimenpiteiden toteuttamiseksi ja
              työsopimuksen implementoimiseksi.
            </p>
            <p>
              Muilta osin työntekijöiden henkilötietojen käsittelyn perusteena ovat työsuhteiden ylläpitämiseen ja kehittämiseen sekä työn
              järjestelyyn liittyvät Aputeamin oikeutetut edut perustuen Aputeamin ja työntekijän väliseen työsuhteeseen. Aputeam käsittelee vain
              työsuhteen kannalta tarpeellisia henkilötietoja.
            </p>
          </p>
          <p>
            <div>5. Käsiteltävät henkilötiedot Rekisteröidystä</div> <p>(työnhakija / työntekijä) käsitellään seuraavia tietoja: </p>
            <p>
              • Työnhakijatiedot pitävät sisällään henkilön perustiedot (nimi, syntymäaika, yhteystiedot ym.), aiempia työsuhteita koskevat tiedot
              (alkamispäivä, tehtävä ym.) sekä ammatti- ja koulutustiedot. Tiedot voivat sisältää myös esim. tietoja mahdollisista työnteon
              rajoitteista, jotka tulisi huomioida työtä tarjottaessa.
            </p>
            <p>
              • Työntekijätietoihin sisältyy edellä mainitun lisäksi työsuhteita koskevia tietoja (alkamispäivä, tehtävä ym.), palkanlaskentatiedot
              (sovellettava työehtosopimus, palkkatiedot ym.), työajanseuranta, vuosiloma, poissaolotiedot (vanhempainvapaat, opintovapaat,
              sairauspoissaolot), työssä kehittymiseen ja suoriutumiseen liittyvät tiedot sekä muut työsuhteeseen liittyvät tarpeelliset tiedot.
            </p>
          </p>
          <div>6. Henkilötietojen säilytysaika</div>
          <p>
            Aputeam käsittelee työnhakijan henkilötietoja rekrytointiprosessin ajan. Prosessin päätyttyä henkilötietoja säilytetään niin kauan, kun on
            tarpeen Aputeamin oikeuksien ja velvollisuuksien täyttämiseksi, kuitenkin enintään 2 vuoden ajan.
          </p>
          <p>
            Aputeam käsittelee työntekijöiden henkilötietoja työsuhteen keston aikana, ylläpitäen henkilötietoja ajantasaisina ja poistaen
            tarpeettomat tiedot säännöllisin väliajoin. Työsuhteen päätyttyä henkilötiedot jäävät passiiviseen säilytykseen. Henkilötietoja poistetaan
            vaiheittain soveltuvan lainsäädännön asettamien määräaikojen mukaisesti, kuten esimerkiksi:
          </p>
          <p>• Työtodistus: pääsääntöisesti 10 vuotta työsuhteen päättymisestä (työsopimuslaki).</p>
          <p>
            • Palkka-aineisto: 10 vuotta tilikauden päättymisestä. Tositteet ja muistiinpanot 6 vuotta sen vuoden lopusta lukien, jonka aikana
            suoritus on maksettu (ennakkoperintälaki).
          </p>
          <p>
            • Vuosilomakirjanpito: 2 vuotta ko. kalenterivuoden päättymisestä, työsuhteen kestäessä, tai 2 vuotta työsuhteen päättymisestä
            (vuosilomalaki).
          </p>
          <p>
            • Työaikakirjanpito: 2 vuotta ko. kalenterivuoden päättymisestä, työsuhteen kestäessä, tai 2 vuotta työsuhteen päättymisestä
            (työaikalaki).
          </p>
          <p>
            • Kirjanpitoaineisto: 10 tai 6 vuotta tilikauden päättymisestä (kirjanpitolaki). Henkilötietoja voidaan säilyttää pidemmän aikaa, mikäli
            tämä on tarpeen lain, asetuksen tai muun viranomaislähteen määräämän velvoitteen täyttämiseksi tai Aputeamin oikeuksien turvaamiseksi
            esimerkiksi oikeudenkäynnissä.
          </p>
          <p>
            <div>7. Säännönmukaiset tietolähteet </div> Tietoja kerätään pääasiassa työnhakijalta tai työntekijältä itseltään. Tietoja voidaan hankkia
            myös työnhakijan aikaisemmilta työnantajilta sekä verkkolomakkeen julkisista tietokannoista.
          </p>
          <p>
            <div>8. Tietojen säännönmukaiset luovutukset </div> Henkilötietoja luovutetaan henkilötietojen käsittelijöinä toimiville kolmansille
            osapuolille, kuten Aputeamin alihankkijoina toimiville palveluntarjoajille, mikäli se on tarpeen rekrytointiprosessin toteuttamiseksi tai
            työsuhdeasioiden hoitamiseksi. Aputeam on varmistanut sopimuksellisin ja muin järjestelyin sen, että henkilötietoja käsitellään vain
            Aputeamin kirjallisten ohjeiden perusteella ja vain tässä tietosuojaselosteessa määriteltyihin tarkoituksiin. Tietoja ei luovuteta muille
            rekisterinpitäjille lukuun ottamatta tilanteita, joissa henkilötietoja luovutetaan laillisella perusteella viranomaisille. Myös muut
            Aputeam-konserniin kuuluvat yhtiöt voivat käsitellä henkilötietoja, mikäli se on tarpeen käsittelyn tarkoitusten toteuttamiseksi.
          </p>
          <p>
            <div>9. Tietojen siirto EU:n tai ETA:n ulkopuolelle</div> Henkilötietoja säilytetään Euroopan talousalueella (ETA) sijaitsevilla
            palvelimilla, mutta osalla Aputeamin alihankkijoista on pääsy henkilötietoihin myös ETA:n ulkopuolelta. Tällaisissa tilanteissa Aputeam
            huolehtii siitä, että alihankkijat sitoutuvat soveltamaan henkilötietojen käsittelyssä riittävää tietosuojan tasoa varmistamalla, että
            tietojen siirrot perustuvat EU:n tietosuoja-asetuksen edellyttämiin asianmukaisiin suojatoimiin, kuten Euroopan komission hyväksymiin
            vakiosopimuslausekkeisiin.
          </p>
          <p>
            <div>10. Rekisterin suojauksen periaatteet</div> Rekisteriin sisältyvät henkilötiedot säilytetään luottamuksellisina. Rekisterin käyttö on
            rekisterinpitäjän organisaatiossa ohjeistettu ja henkilörekisteriin pääsy on rajattu siten, että järjestelmään tallennettuihin rekisterin
            sisältämiin tietoihin pääsevät käsiksi ja niitä ovat oikeutettuja käyttämään vain ne työntekijät, joilla on työtehtäviensä puolesta siihen
            oikeus ja jotka tarvitsevat tietoja tehtävässään. Henkilötietoja käsittelevällä henkilöstöllä on vaitiolovelvollisuus. Järjestelmä on
            suojattu suojausohjelmiston avulla. Järjestelmään sisäänpääsy edellyttää kultakin rekisterin käyttäjältä salasanan syöttämistä. Palvelin
            on suojattu salasanoilla ja asianmukaisella palomuurilla. Henkilötietoja sisältävät järjestelmät vaativat sisäänkirjautumisen
            salasanoilla. Palvelimen ja käyttäjän koneen välinen tietoliikenne kulkee salattuna. Lisäksi rekisterinpitäjän tietoverkko ja laitteisto,
            jolla rekisteri sijaitsee, on suojattu palomuurilla ja muiden teknisten toimenpiteiden avulla. Henkilötietoja sisältävien aineistojen
            hävitys tehdään tietoturvallisesti. Mahdollinen manuaalinen aineisto säilytetään lukitussa tilassa, johon on pääsy vain erikseen
            nimetyillä henkilöillä.
          </p>
          <p>
            <div>11. Automaattinen päätöksenteko </div> Henkilötietoja ei käytetä sellaiseen automaattiseen päätöksentekoon, jolla olisi oikeudellisia
            tai vastaavia vaikutuksia rekisteröidyille.
          </p>
          <p>
            <div>12. Rekisteröidyn oikeus vastustaa henkilötietojen käsittelyä </div> Rekisteröidyllä on oikeus henkilökohtaiseen erityiseen
            tilanteeseensa liittyen vastustaa itseensä kohdistuvaa profilointia ja muita käsittelytoimia, joita rekisterinpitäjä kohdistaa
            rekisteröidyn henkilötietoihin siltä osin, kun tietojen käsittelemisen perusteena on rekisterinpitäjän oikeutettu etu. Ottaen huomioon
            käsittelyperuste ja käsittelyn tarkoitus rekisteröidyllä ei ole oikeutta kaikkien henkilötietojensa osalta eikä Aputeamilla ole
            velvollisuutta olla käsittelemättä työsuhteen kannalta välttämättömiä tietoja. Aputeam voi näin ollen kieltäytyä rekisteröidyn pyynnön
            toteuttamisesta esimerkiksi sovellettavassa laissa säädetyllä perusteella, jolloin kyseiset perusteet ilmoitetaan rekisteröidylle.
          </p>
          <p>
            <div>13. Analytiikka </div>
            <p>
              Verkkosivustolla käytetään Googlen (Google Inc.) toimittamaa Google Analytics -ohjelmaa, joka helpottaa sivuston käytön seurantaa. Tähän
              tarkoitukseen Google Analytics käyttää evästeitä, jotka ovat käyttäjän tietokoneelle siirrettäviä tekstitiedostoja. Tämän verkkosivuston
              käytöstä evästeillä luotu tieto siirtyy ja tallentuu Googleen. Käyttäjän IP-osoite anonymisoidaan ennen kuin se lähetetään Googleen.
              Privacy Shield -varmennuksensa mukaisesti Google ilmoittaa, että se noudattaa EU:n ja Yhdysvaltain Privacy Shield - järjestelyä. Google
              voi toimittaa Google Analyticsin keräämiä tietoja kolmansille osapuolille lain sitä edellyttäessä tai kolmansien osapuolten käsitellessä
              tietoja Googlen puolesta. Google Analyticsin käyttöehtojen mukaan Google ei yhdistä rekisteröityjen IP-osoitteita mihinkään muuhun
              Googlessa säilytettävään tietoon. Google Analyticsin evästeiden käytön voi estää lataamalla ja ottamalla käyttöön
              <b>Google Analytics Opt-out Browser Add-on -vaihtoehdon.</b>
            </p>
            <p> • Google Analytics -ohjelman Opt-out Browser Add-on </p>
            <p>
              Aputeam.fi-sivusto käyttää suostumuksellasi evästeitä sivuston käyttäjäkokemuksen parantamiseksi ja analytiikan seuraamiseksi.
              Lisätietoja evästeiden käytöstä saat evästeasetuksista, mistä voit myös valita käytettävät evästeet. Voit estää evästeiden käytön
              kokonaan tietokoneellasi muuttamalla selaimesi asetuksia. Asetusten sijainti riippuu selaimesta. Kannattaa kuitenkin ottaa huomioon,
              että monet toiminnot ja palvelut edellyttävät, että verkkosivusto tallentaa tekemäsi valinnat. Jos estät evästeet, et välttämättä voi
              käyttää kaikkia toimintoja ja palveluja. Kaikissa selaimissa evästeet voi poistaa yksitellen tai yhdellä kertaa. Poistotoiminnon
              sijainti riippuu selaimesta. Alla olevista linkeistä saat ohjeita oman selaimesi asetuksista.
            </p>
            <p>• Evästeiden poistaminen / Microsoft Internet Explorer </p> <p>• Evästeiden poistaminen / Google Chrome </p>
            <p>• Evästeiden poistaminen / Mozilla Firefox </p>
            <p>• Evästeiden poistaminen / Opera Emme jaa evästetietoja kolmansille osapuolille.</p>
          </p>
          <p>
            <div>14. Muut henkilötietojen käsittelyyn liittyvät rekisteröidyn oikeudet </div>
            <p>
              <div>Rekisteröidyn tarkastus- ja oikaisuoikeus</div>
            </p>
            Rekisteröidyllä on oikeus tarkastaa, mitä häntä koskevia tietoja rekisteriin on tallennettu. Jos tiedot ovat virheelliset, epätarkat tai
            puutteelliset tulee rekisteröidyn tehdä rekisterinpitäjälle oikaisu- tai täydennyspyyntö.
            <p>
              <div> Rekisteröidyn oikeus vaatia tiedon poistamista tai käsittelyn rajoittamista </div>
            </p>
            Rekisteröidyllä on oikeus pyytää tietojen poistamista ja Aputeamin on poistettava tiedot, jollei henkilötietojen käsittely perustu
            lainsäädännön velvoitteisiin tai ole muutoin tarpeen esimerkiksi oikeusvaateen laatimiseksi. Rekisteröidyllä on oikeus vaatia
            rekisterinpitäjää rajoittamaan henkilötietojensa käsittelyä esimerkiksi siinä tilanteessa, kun rekisteröity odottaa rekisterinpitäjän
            vastausta tietojensa oikaisemista tai poistamista koskevaan pyyntöön.
            <p>
              <div>Rekisteröidyn oikeus siirtää tiedot järjestelmästä toiseen</div>
            </p>
            Siltä osin kun rekisteröity on itse toimittanut rekisteriin tietoja, joita käsitellään rekisteröidyn antaman suostumuksen nojalla,
            rekisteröidyllä on oikeus saada tällaiset tiedot itselleen ja oikeus siirtää nämä tiedot toiselle rekisterinpitäjälle.{' '}
            <p>
              <div>Muut oikeudet</div>
            </p>
            Mikäli henkilötietoja käsitellään rekisteröidyn suostumukseen perustuen, rekisteröidyllä on oikeus perua suostumuksensa ilmoittamalla
            tästä rekisterinpitäjälle. Rekisteröidyllä on oikeus tehdä kantelu tietosuojavaltuutetulle (www.tietosuoja.fi), jos rekisteröity katsoo,
            että Aputeam on käsitellyt henkilötietoja tietosuojalainsäädännön vastaisesti.
          </p>
          <p>
            <div>15. Yhteydenotot</div> Rekisteröidyn tulee kaikissa henkilötietojensa käsittelyyn ja omien oikeuksiensa käyttämiseen liittyvissä
            kysymyksissä ottaa yhteyttä rekisterinpitäjään kohdassa 2 mainittua sähköpostiosoitetta käyttäen.
          </p>
        </div>
      </Modal>

      <div className="c-login-background" style={{ backgroundImage: `url(${window.origin + props.backgroundUrl}` }}></div>
      <div className="c-login__version__timestamp">Versio: {moment(dateTimeStamp).format('DD.MM.YYYY HH:mm ')}</div>
      <div className="c-login" style={{ position: 'relative' }}>
        <Logo imageUrl={props.logoUrl} style={{ marginRight: '1.5em', marginBottom: '3em' }} />
        <Form name="basic" initialValues={{ remember: true }} onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off">
          {/* Email */}
          <Form.Item name={props.type} rules={[{ message: `Anna ${usernameFieldName}!`, type: 'string' }]} style={{ marginBottom: '1em' }}>
            <Input placeholder={'Sähköposti'} style={{ width: '200px', marginBottom: '1.5em' }} />
          </Form.Item>
          {/* Password */}
          <Form.Item name="password" rules={[{ message: 'Anna Salasana!' }]} className="c-login__password-form-item">
            <Input.Password placeholder="Salasana" style={{ width: '200px' }} className="c-login__password-form-item__input" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
            <Button
              style={{ position: 'fixed', bottom: '0em', right: '1em', color: 'white' }}
              label="Oletko unohtanut salasanasi?"
              color="default"
              onClick={() => {
                setShowResetPasswordModal(true)
              }}
            />
          </Form.Item>
          {/*
                    <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 8, span: 16 }}>
                        <Checkbox>Remember me</Checkbox>
                    </Form.Item> */}

          <Form.Item wrapperCol={{ offset: 8, span: 16 }} style={{ marginTop: '0em' }}>
            <Button label="Kirjaudu" type="submit" color="blue" onClick={() => {}} style={{ marginTop: '0em' }} />
          </Form.Item>
        </Form>

        <div
          style={{ position: 'absolute', bottom: '1em', right: '1em', cursor: 'pointer' }}
          onClick={() => {
            setShowDisclaimer(true)
          }}
        >
          Tietosuojaseloste
        </div>
      </div>
      <ResetPassword
        visible={showResetPasswordModal}
        onSave={async (value) => {
          try {
            await resetPasswordPost(value.email)
            Notification.success({ message: 'Salasana muutos ohjeet lähetetty' })
            setShowResetPasswordModal(false)
          } catch (e) {
            console.log(e)
            Notification.error({ message: JSON.stringify(e) })
            setShowResetPasswordModal(false)
          }
        }}
        onCancel={() => {
          setShowResetPasswordModal(false)
        }}
      />
    </div>
  )
}
